<template>

	<div v-if="this.isVideoLesson" style="width:100%">
		<div v-if="this.showPreviewImage" class="overlay" :style="{ background: backgroundImage }" @click="onClickOverlay">
			<div class="playBtn">
				<span class="material-icons iconSize48" style="height: 3rem;">play_arrow</span>
			</div>
		</div>
		<VideoPlayer v-else-if="this.autoPlay" autoPlay embedded />
		<VideoPlayer v-else embedded />
	</div>

	<div v-else v-html="this.$root.lessonData.description" class="textLesson" />

</template>

<script>
import Logger from '@/assets/scripts/logger.js'
//import VideoPlayer from '@/components/VideoPlayer'
//import '@/assets/css/videoPlayer.css'
import $ from 'jquery'

export default {
	name: 'Embedded',
	autoPlay: false,
	components: {
		// VideoPlayer
		VideoPlayer: () => import('@/components/VideoPlayer')
	},
	data() {
		return {
			isVideoLesson : this.$root.lessonData.isVideoLesson,
			showPreviewImage : this.$root.lessonData.videoPlayerData && this.$root.lessonData.videoPlayerData.previewUrl ? true : false
		}
	},
	computed: {
		backgroundImage() {
			if (this.isVideoLesson) {
				if (this.$root.lessonData.videoPlayerData.previewUrl) {
					return "#000 url('" + this.$root.lessonData.videoPlayerData.previewUrl + "') no-repeat center / cover";
				}
			}
			return "none";
		}
	},
	created() {
		Logger.log("Embedded.vue created");
		$("body").css("background", this.isVideoLesson ? "#000000" : "#ffffff");
	},
	methods: {
		onClickOverlay() {
			Logger.log("Embedded.vue onClickOverlay");

			// the preview image was aleady shown, we no longer need it
			this.$root.lessonData.videoPlayerData.previewUrl = null;

			this.autoPlay = true;
			this.showPreviewImage = false;
		}
	}
}
</script>

<style lang="scss" scoped>

	@import '@/assets/scss/_definitions.scss';

	$buttonSize: 5rem;
	$buttonSizeSmall: $buttonSize * 0.75;

	.overlay {
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		cursor: pointer;
		z-index: 100;
	}

	.playBtn {
		position: absolute;
		top: 50%;
		left: 50%;
		@include transform(translate(-50%, -50%));
		display: inline-block;
		font-size: 3rem; 
		height: $buttonSize;
		line-height: $buttonSize;
		text-align: center;
		width: $buttonSize;
		@include borderRadius(50%);	
		@include skinColor(background-color, --skinColSec, $skinColSec, 0.8);
		@include skinColor(color, --skinColSecCompl, $skinColSecCompl, 0.8);

		&:hover {
			@include skinColor(background-color, --skinColSec, $skinColSec);
			@include skinColor(color, --skinColSecCompl, $skinColSecCompl);
		}
		
		span {
			position: absolute;
			top: 50%;
			left: 50%;
			@include transform(translate(-50%, -50%));
		}

		@media only screen and (max-width: $break3) {	
			height: $buttonSizeSmall;
			line-height: $buttonSizeSmall;
			width: $buttonSizeSmall;
		}
	}

	.textLesson {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		overflow: auto;
		padding: 1rem;

		::v-deep a {
			font-weight: 600;
			text-decoration: underline;
			white-space: nowrap;
		}
	}

</style>
